// src/hooks/usePlan.js
// Checks user's plan tier and gates Pro features
// Free users see the feature exists but hit an upgrade prompt
// Manually upgrade users in Supabase: update profiles set plan = 'pro' where id = 'user-id'
import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../context/AuthContext';

export function usePlan() {
  const { user } = useAuth();
  const [plan,    setPlan]    = useState('free');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { setLoading(false); return; }
    supabase.from('profiles').select('plan').eq('id', user.id).single()
      .then(({ data }) => {
        setPlan(data?.plan || 'free');
        setLoading(false);
      });
  }, [user]);

  const isPro  = plan === 'pro';
  const isFree = plan === 'free';

  // Feature gates
  const can = {
    fullDiagnostic:    isPro,
    improvementPlan:   isPro,
    aiWeeklyReport:    isPro,
    patternInsightsFull: isPro,
    csvImport:         true,  // everyone
    csvExport:         true,  // everyone
    odfScore:          true,  // everyone
    basicStats:        true,  // everyone
  };

  return { plan, isPro, isFree, can, loading };
}
